/**
 * 定價計算相關類型定義
 */
/**
 * 進位模式
 */
export var RoundingMode;
(function (RoundingMode) {
    /** 四捨五入（預設） */
    RoundingMode["ROUND"] = "round";
    /** 無條件捨去 */
    RoundingMode["FLOOR"] = "floor";
    /** 無條件進位 */
    RoundingMode["CEIL"] = "ceil";
})(RoundingMode || (RoundingMode = {}));
